import initIndex from './utilities/algoliaInitIndex'
import createFilter from './utilities/algoliaCreateFilter'

const itemsIndex = initIndex('items')

const algoliaSearchJerseyName =
	(query, brandName, gender) => itemsIndex.search({
		query,
		filters: createFilter({ itemType: 'jersey', brandName, gender }),
		hitsPerPage: 50,
		page: 0
	}).catch((error) => { //  TODO: Add to error types/messages
		console.log('ALGOLIA ERROR', error)
		return { error, query }
	})

export default algoliaSearchJerseyName



// WEBPACK FOOTER //
// ./src/dataservices/algoliaSearchJerseyName.js